<template>
  <div class="pagation">
    <div class="item" v-if="info.left_right_articles">
      上一篇：<span
        v-text="info.left_right_articles.left_name"
        @click="jumpPage(info.left_right_articles.left_id)"
      ></span>
    </div>
    <div class="item" v-if="info.left_right_articles">
      下一篇：<span
        v-text="info.left_right_articles.right_name"
        @click="jumpPage(info.left_right_articles.right_id)"
        >他说的发送到发送到发斯蒂芬</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      require: true,
      default: () => ({
        left_right_articles: {
          left_id: null,
          left_name: null,
          right_id: null,
          right_name: null
        }
      })
    }
  },
  created() {
    
  },
  methods:{
    jumpPage(id) {
      const { name } = this.$route;
      this.$router.push({
        name,
        params:{
          id
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.pagation {
  margin-bottom: 20px;
  .item {
    margin-bottom: 10px;
    span {
      cursor: pointer;
      &:hover {
        color: #0091ff;
        border-bottom: 1px solid #0091ff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detailPagation.vue